import React from 'react';
import { Reveal } from './Reveal';
import { transformationStats } from '../data/content';
export function Transformation() {
  return <section className="w-full bg-cream px-5 py-24 sm:py-32" data-id="element-204" data-mp="il2ojkleblxq">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-205" data-mp="mlmk4jqbmhhr">
        <div className="mx-auto max-w-[720px] text-center" data-id="element-206" data-mp="mo8vkugc1h59">
          <Reveal data-id="element-207" data-mp="rma96zuzoo9c">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-muted" data-id="element-208" data-mp="rmse0kvpwasv">
              Det du får ud af det
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-209" data-mp="11ivku41ikxm5">
            <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-210" data-mp="11hu53m9jzmy3">
              Fra overvældet frivillig til{' '}
              <span className="font-serif text-[0.9em] normal-case italic text-red" data-id="element-211" data-mp="1abysfvphag8v">
                en træner, der ved besked
              </span>
            </h2>
          </Reveal>

          <Reveal delay={0.12} data-id="element-212" data-mp="1k9d7bqvr6wz2">
            <p className="mx-auto mt-7 max-w-[620px] text-base leading-relaxed text-ink sm:text-[17px]" data-id="element-213" data-mp="1kaod1w8reest">
              Du mangler ikke øvelser. Der findes tusindvis derude, og mange af dem er
              gode. Det, du mangler, er en sæson, der allerede er lagt ud — så du ved,
              hvad I laver i uge 41, uden at skulle finde på det søndag aften.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.16} data-id="element-214" data-mp="y7todltfvacg">
          <dl className="mx-auto mt-14 grid max-w-3xl grid-cols-1 divide-y divide-line rounded-card border border-line bg-white shadow-card sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-215" data-mp="y8lnh6m8vq7h">
            {transformationStats.map(stat => <div key={stat.label} className="flex flex-col items-center px-6 py-9 text-center" data-id="element-216" data-mp="1m3ejlj8md8ek">
                <dt className="font-serif text-5xl font-normal not-italic leading-none text-navy" data-id="element-217" data-mp="1h4uy1jxxtymq">
                  {stat.value}
                </dt>
                <dd className="mt-4 text-[11px] font-semibold uppercase leading-snug tracking-[0.16em] text-muted" data-id="element-218" data-mp="29t8ys7gev91z">
                  {stat.label}
                </dd>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </section>;
}